const MOBILE_SCAN_CAPABLE_DEVICES = [
  'iPhone10,3', // iPhone X Global
  'iPhone10,6', // iPhone X GSM
  'iPhone11,2', // iPhone XS
  'iPhone11,4', // iPhone XS Max
  'iPhone11,6', // iPhone XS Max Global
  'iPhone11,8', // iPhone XR
  'iPhone12,1', // iPhone 11
  'iPhone12,3', // iPhone 11 Pro
  'iPhone12,5', // iPhone 11 Pro Max
  'iPhone13,1', // iPhone 12 Mini
  'iPhone13,2', // iPhone 12
  'iPhone13,3', // iPhone 12 Pro
  'iPhone13,4', // iPhone 12 Pro Max
  'iPhone14,2', // iPhone 13 Pro
  'iPhone14,3', // iPhone 13 Pro Max
  'iPhone14,4', // iPhone 13 Mini
  'iPhone14,5', // iPhone 13
  'iPhone14,7', // iPhone 14
  'iPhone14,8', // iPhone 14 Plus
  'iPhone15,2', // iPhone 14 Pro
  'iPhone15,3', // iPhone 14 Pro Max
  'iPhone15,4', // iPhone 15
  'iPhone15,5', // iPhone 15 Plus
  'iPhone16,1', // iPhone 15 Pro
  'iPhone16,2', // iPhone 15 Pro Max
  'iPhone17,1', // iPhone 16 Pro
  'iPhone17,2', // iPhone 16 Pro Max
  'iPhone17,3', // iPhone 16
  'iPhone17,4', // iPhone 16 Plus

  // iPad
  'iPad8,1', // iPad Pro 11 inch 3rd Gen (WiFi)
  'iPad8,2', // iPad Pro 11 inch 3rd Gen (1TB, WiFi)
  'iPad8,3', // iPad Pro 11 inch 3rd Gen (WiFi+Cellular)
  'iPad8,4', // iPad Pro 11 inch 3rd Gen (1TB, WiFi+Cellular)
  'iPad8,5', // iPad Pro 12.9 inch 3rd Gen (WiFi)
  'iPad8,6', // iPad Pro 12.9 inch 3rd Gen (1TB, WiFi)
  'iPad8,7', // iPad Pro 12.9 inch 3rd Gen (WiFi+Cellular)
  'iPad8,8', // iPad Pro 12.9 inch 3rd Gen (1TB, WiFi+Cellular)
  'iPad8,9', // iPad Pro 11 inch 4th Gen (WiFi)
  'iPad8,10', // iPad Pro 11 inch 4th Gen (WiFi+Cellular)
  'iPad8,11', // iPad Pro 12.9 inch 4th Gen (WiFi)
  'iPad8,12', // iPad Pro 12.9 inch 4th Gen (WiFi+Cellular)
  'iPad13,4', // iPad Pro 11 inch 5th Gen
  'iPad13,5', // iPad Pro 11 inch 5th Gen
  'iPad13,6', // iPad Pro 11 inch 5th Gen
  'iPad13,7', // iPad Pro 11 inch 5th Gen
  'iPad13,8', // iPad Pro 12.9 inch 5th Gen
  'iPad13,9', // iPad Pro 12.9 inch 5th Gen
  'iPad13,10', // iPad Pro 12.9 inch 5th Gen
  'iPad13,11', // iPad Pro 12.9 inch 5th Gen
  'iPad14,3', // iPad Pro 11 inch 4th Gen
  'iPad14,4', // iPad Pro 11 inch 4th Gen
  'iPad14,5', // iPad Pro 12.9 inch 6th Gen
  'iPad14,6', // iPad Pro 12.9 inch 6th Gen
  'iPad14,8', // iPad Air 6th Gen
  'iPad14,9', // iPad Air 6th Gen
  'iPad14,10', // iPad Air 7th Gen
  'iPad14,11', // iPad Air 7th Gen
  'iPad16,3', // iPad Pro 11 inch 5th Gen
  'iPad16,4', // iPad Pro 11 inch 5th Gen
  'iPad16,5', // iPad Pro 12.9 inch 7th Gen
  'iPad16,6', // iPad Pro 12.9 inch 7th Gen
];

export default MOBILE_SCAN_CAPABLE_DEVICES;
